import { render, staticRenderFns } from "./ShowCustomers.vue?vue&type=template&id=0e3670ec&"
import script from "./ShowCustomers.vue?vue&type=script&lang=js&"
export * from "./ShowCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports